var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAccess)?_c('section',{staticClass:"skills-main"},[_c('skills-organization-v-2')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }